const formValidation = evt => {
  const form = evt.target

  if (!form.checkValidity()) {
    return false
  }

  evt.preventDefault()
  return true
}

export default formValidation
